import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import store from './store.js'


Vue.use(Vuex);

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

// FontAwesome設定
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload'
import { faHandPointLeft } from '@fortawesome/free-solid-svg-icons/faHandPointLeft'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUpload, faHandPointLeft)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
